import { BasicGroupDTO } from '../../members/dtos/BasicGroup.dto';
import { BasicGroupsModel } from '../../members/models/BasicGroups.model';

export class BasicGroupUtil {
  public static mapToViewModel(dto: BasicGroupDTO): BasicGroupsModel {
    return {
      id: dto.id,
      group: dto.group,
    };
  }
}
